import { Span } from "@virtual-brain-lib/frontend-design-system/ui";
import type { Content } from "@virtual-brain-lib/types";

interface MarkdownInlineSourceTooltipProps {
	readonly contentId?: string | undefined;
	readonly content?: Content | undefined;
	readonly excerpt: string;
	readonly index: string;
	readonly imageUrl?: string | undefined;
}

export default function MarkdownInlineSourceTooltip({
	contentId,
	content,
	excerpt,
	index,
	imageUrl,
}: MarkdownInlineSourceTooltipProps) {
	if (contentId === "linkup" || contentId === "perplexity") {
		return (
			<div>
				<Span className="text-[16px] font-semibold break-all">{excerpt}</Span>
				<div className="mt-3 rounded-xs bg-gray-100 p-3 text-sm">
					Click on{" "}
					<span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-blue-100 text-sm font-bold text-blue-800 shadow-xs">
						{index}
					</span>{" "}
					to access source.
				</div>
			</div>
		);
	}

	return (
		<div className="flex flex-col gap-1">
			<Span variant="body-md" className="font-semibold break-all">
				{content?.title}
			</Span>
			{imageUrl && (
				<img
					src={imageUrl}
					alt="Source preview"
					className="mb-2 h-auto w-full rounded-md"
					style={{ maxHeight: "200px", objectFit: "cover" }}
				/>
			)}
			<Span
				variant="body-sm"
				color="primary"
				className="mt-2 overflow-hidden leading-relaxed break-words"
			>
				{excerpt}
			</Span>
			<div className="mt-3 rounded-xs border border-secondary-border bg-primary-light p-3 text-sm">
				Click on{" "}
				<span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-secondary text-sm font-bold text-on-secondary shadow-xs">
					{index}
				</span>{" "}
				to access source document.
			</div>
		</div>
	);
}
